import { useMutation } from '@apollo/client';

import {
  UpdateEmailMutation,
  UpdateEmailMutationVariables,
} from '../graphql/generated';
import { UPDATE_EMAIL } from '../graphql/mutations';

const useUpdateEmail = () => {
  const [updateEmail, result] = useMutation<
    UpdateEmailMutation,
    UpdateEmailMutationVariables
  >(UPDATE_EMAIL);

  return {
    updateEmail,
    ...result,
  };
};

export default useUpdateEmail;
